export const getEnv = () => {
  const { hostname } = window.location;

  if (hostname === 'dev.cdvistratus.com') {
    return 'dev';
  }

  if (hostname === 'qa.cdvistratus.com') {
    return 'qa';
  }

  if (hostname === 'ca.cdvistratus.com') {
    return 'production-ca';
  }

  if (hostname === 'us.cdvistratus.com') {
    return 'production-us';
  }

  if (hostname === 'eu.cdvistratus.com') {
    return 'production-eu';
  }

  if (hostname === 'localhost') {
    return 'localhost';
  }

  return '';
};
